import React, { useEffect, useState } from 'react';
import moment from 'moment';

const Countdown = ({ targetDate }) => {
    const calculateTimeLeft = () => {
        const now = moment();
        const end = moment(targetDate);
        const diff = end.diff(now);

        return diff > 0 ? diff : 0;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(interval);
    }, [targetDate]);

    const formatTime = (ms) => {
        const duration = moment.duration(ms);
        const hours = Math.floor(duration.asHours());
        const minutes = String(duration.minutes()).padStart(2, '0');
        const seconds = String(duration.seconds()).padStart(2, '0');

        if (hours > 0) {
            return `${hours}:${minutes}:${seconds}`;
        }
        return `${minutes}:${seconds}`;
    };

    return (
        <span style={{ color: timeLeft === 0 ? 'red' : 'inherit' }}>
            {timeLeft === 0 ? 'Expirat' : formatTime(timeLeft)}
        </span>
    );
};

export default Countdown;
